import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useHistory } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import * as fromCourseActions from 'store/actions/courses.action'
import { IMainState } from 'store/states'
import { CourseStateType } from 'enum'
import Button from 'design-system/button'
import { ButtonSizes } from 'design-system/button/src/Button'
import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'

const modalPrefix =
  'administration.courses.new.form.invitationNotification.confirmationModal'

const PublishButton: React.FC<{
  draggable: boolean
  disabled?: boolean
}> = ({ draggable, disabled }) => {
  const { t } = useTranslation()

  const { courseId } = useParams<Record<'courseId', string>>()
  const dispatch = useDispatch()
  const history = useHistory()

  const { course } = useSelector(({ courses }: IMainState) => courses)

  const [buttonLoading, setButtonLoading] = useState(false)
  const [showPublishConfirmation, setShowPublishConfirmation] = useState(false)
  const handlePublish = () => {
    setButtonLoading(true)
    dispatch({
      type: fromCourseActions.PUBLISH_COURSE,
      payload: {
        course: { state: CourseStateType.Published },
        courseId,
        onlySave: true,
      },
    })
    history.push('/administration/courses/')
  }

  const notification = course.invitationNotification
  const invitationWillSent = notification ? !notification.sent : false

  const onPublish = () => {
    if (invitationWillSent) return setShowPublishConfirmation(true)
    handlePublish()
  }

  const handleClosePublishModal = () => {
    setShowPublishConfirmation(false)
  }

  return (
    <>
      <Button
        className="ml-0"
        disabled={buttonLoading || draggable || disabled}
        size={ButtonSizes.Small}
        onClick={() => !buttonLoading && !draggable && onPublish()}
      >
        {buttonLoading ? (
          <FontAwesomeIcon icon={faSpinner} spin className="mr-1" />
        ) : (
          <FontAwesomeIcon icon={faCheck} className="mr-2" />
        )}
        {t('administration.lessons.buttons.publish')}
      </Button>
      <ConfirmationModal
        show={invitationWillSent && showPublishConfirmation}
        title={t(`${modalPrefix}.header`)}
        acceptButtonText={t(`${modalPrefix}.continue`)}
        text={t(`${modalPrefix}.text`)}
        onAccept={() => handlePublish()}
        onClose={() => handleClosePublishModal()}
      />
    </>
  )
}

export default PublishButton
